"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var FolderOpenOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M166.485 938.667c-10.026 0-19.626-1.814-28.458-5.12l-4.438-1.216a123.157 123.157 0 01-24.725-10.112 120.192 120.192 0 01-49.75-49.75c-12.223-22.826-16.447-44.736-16.447-85.866V280.064c0-41.13 4.224-63.04 16.426-85.867a120.192 120.192 0 0149.771-49.749C131.691 132.224 153.6 128 194.731 128H384a42.667 42.667 0 0132.768 15.36L510.656 256h299.861a128 128 0 01127.915 123.243l.085 4.8-.064 42.624h11.499a64 64 0 0163.893 60.245l.107 3.755a64 64 0 01-4.501 23.573L862.592 884.779a85.333 85.333 0 01-79.339 53.888zM918.507 512H329.365l-156.01 340.8 7.424.341 8.874.171H256v.021h527.253L918.507 512zM364.01 213.333H189.653l-8.874.192-7.382.342c-10.069.64-15.872 1.984-20.97 4.202l-3.307 1.622c-6.485 3.456-11.307 8.277-14.763 14.762l-1.621 3.307c-2.219 5.099-3.541 10.901-4.203 20.97l-.341 7.382-.192 8.875V746.88l129.472-282.837a64 64 0 0154.037-37.227l4.16-.128H853.1l.085-42.56c0-22.613-17.408-41.024-39.467-42.667l-3.2-.106h-319.85a42.667 42.667 0 01-32.768-15.36L364.01 213.333z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
FolderOpenOutlined.displayName = "FolderOpenOutlined";
var _default = exports["default"] = FolderOpenOutlined;